<template>
  <b-form-row>
    <b-col>
      <column-picker :column="column" :prepend="prepend" :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                     :isRequired="isRequired" :defaultOptionText="defaultOptionText" :isGrouping="isGrouping" :isSubGrouping="isSubGrouping"
                     :isAggregate="isAggregate" @change="columnChanged" :allowedDataTypes="allowedDataTypes">
      </column-picker>
    </b-col>
    <b-col>
      <b-form-group label="Label:" v-if="hasLabel">
        <b-form-input v-model="column.label" :required="isRequired" @change="emitChange"></b-form-input>
      </b-form-group>
    </b-col>
  </b-form-row>
</template>

<script>
import ColumnPicker from '@/components/reports/ColumnPicker'

export default {
  name: 'ColumnEditor',
  props: ['column', 'columnSpecCategories', 'reportType', 'report', 'isRequired', 'defaultOptionText', 'isGrouping', 'isSubGrouping', 'isAggregate', 'prepend', 'hasLabel', 'allowedDataTypes'],
  components: { 'column-picker': ColumnPicker },
  computed: {
    allColumnSpecsById () {
      var columns = {}
      this.columnSpecCategories.forEach((category) => {
        category.columns.forEach((column) => {
          columns[column.id] = column
        })
      })
      return columns
    },
    defaultColumnLabel () {
      if (this.column.column_id == null) {
        return ''
      }
      if (this.selectedColumnSpec.column_type === 'converter') {
        const subColumn = this.column.sub_columns[0]
        if (subColumn != null && subColumn.column_id != null) {
          return this.selectedColumnSpec.default_label + ' ' + this.findColumnSpec(subColumn.column_id).default_label
        } else {
          return ''
        }
      } else {
        return this.selectedColumnSpec.default_label
      }
    },
    selectedColumnSpec () {
      if (this.column.column_id != null) {
        return this.allColumnSpecsById[this.column.column_id]
      } else {
        return null
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    findColumnSpec (columnId) {
      return this.allColumnSpecsById[columnId]
    },
    updateLabel () {
      if (this.column.column_id != null) {
        this.column.label = this.defaultColumnLabel
      } else {
        this.column.label = ''
      }
    },
    columnChanged () {
      this.updateLabel()
    },
    emitChange () {
      this.$emit('change', this.column)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/ColumnEditor.vue